<div class="wrapper-page">
  <app-my-content></app-my-content>
  <div class="wrapper-my-profile-page">
    <tl-header></tl-header>
    <div class="content-profile-page">
      <div class="wrapper-info-my-profile">
        <div class="wrapper-info-my-profile-left">
          <img *ngIf="!profileData?.profile_photo_url"
            [src]="(profileData?.subscriptions | checkActiveRole) === UserRoles.freemium || (profileData?.subscriptions | checkActiveRole) === UserRoles.aLister ? '../../../assets/images/avatar-user.png' : '../../../assets/images/avatar-user-expert.png'"
            alt="">
          <img *ngIf="profileData?.profile_photo_url" [src]="profileData?.profile_photo_url" alt="">
          <div class="wrapper-username">
            <span>{{profileData?.username}}</span>
            <div class="badge">
              <img *ngIf="(profileData?.subscriptions | checkActiveRole) === UserRoles.expert"
                src="../../../assets/icons/fill/icon-badge.svg" alt="">
              <img *ngIf="(profileData?.subscriptions | checkActiveRole) === UserRoles.company"
                src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
              <span [ngClass]="{'color-white': (profileData?.subscriptions | checkActiveRole) === UserRoles.company || (profileData?.subscriptions | checkActiveRole) === UserRoles.expert}">{{profileData?.subscriptions | checkActiveRole}}</span>
            </div>
          </div>
        </div>
        <div class="wrapper-info-my-profile-right">
          <div class="wrapper-counter-box">
            <div class="item-box" [routerLink]="'/lists/my_lists'" *ngIf="isAuthUserProfile">
              <span class="number">{{profileData?.lysts_count}}</span>
              <span>{{profileData?.lysts_count === 1 ? 'lyst' : 'lysts'}}</span>
            </div>
            <div class="item-box" *ngIf="!isAuthUserProfile" style="cursor: auto">
              <span class="number">{{profileData?.lysts_count}}</span>
              <span>{{profileData?.lysts_count === 1 ? 'lyst' : 'lysts'}}</span>
            </div>
            <div
              [routerLink]="[PAGES_AND_PATHS.followingFollowers.pagePath, isAuthUserProfile ? 0 : userId, profileData?.username, 'followers']"
              class="item-box">
              <span class="number">{{profileData?.followers_count}}</span>
              <span>{{profileData?.followers_count === 1 ? 'follower' : 'followers'}}</span>
            </div>
            <div
              [routerLink]="[PAGES_AND_PATHS.followingFollowers.pagePath, isAuthUserProfile ? 0 : userId, profileData?.username, 'following']"
              class="item-box">
              <span class="number">{{profileData?.followings_count}}</span>
              <span>{{'NEW_TEXT.following' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper-name-desc">
        <span class="name">{{profileData?.name}}</span>
        <span class="country xs-mb-0">{{profileData?.country}}</span>
        <span class="desc xs-mt-12">{{profileData?.bio}}</span>
        <!--    TODO Nemanja - Skloni *ngIf i povzi ovo    -->
        <div *ngIf="!isAuthUserProfile" class="wrapper-likes-and-more-btn xs-mt-12">
          <div class="wrapper-likes">
            <button (click)="toggleFavoriteProfile()" class="custom-btn custom-btn--circle-outline">
              <img *ngIf="profileData?.am_i_favorite_this_user" class="like" src="../../../../assets/icons/fill/icon-heart.svg" alt="">
              <img *ngIf="!profileData?.am_i_favorite_this_user" class="no-like" src="../../../../assets/icons/outline/icon-heart.svg" alt="">
            </button>
          </div>
        </div>
      </div>
      <ins class="adsbygoogle" style="display:block; width:300px; height:50px" data-ad-client="ca-pub-3815670526990127"
        data-ad-slot="5923694019" data-ad-format="auto" data-full-width-responsive="true">
      </ins>
      <div class="wrapper-btns-my-profile">
        <button *ngIf="isAuthUserProfile" class="custom-btn custom-btn--gray"
          [routerLink]="[PAGES_AND_PATHS.editProfile.pagePath]">
          <span>{{'NEW_TEXT.edit_profile' | translate}}</span>
          <img src="../../../assets/icons/outline/icon-edit.svg" alt="">
        </button>
        <button class="custom-btn custom-btn--gray" (click)="isShareProfileModalOpen = true">
          <span>{{'NEW_TEXT.share_profile' | translate}}</span>
          <img src="../../../assets/icons/outline/icon-share.svg" alt="">
        </button>
        <!--   Message     -->
        <button
          *ngIf="!isAuthUserProfile && profileData?.am_i_following_this_user && profileData?.does_this_user_follow_me"
          (click)="goToChatWithUser()" class="custom-btn custom-btn--gray tl-justify-center">
          <span class="xs-ml-0">{{'NEW_TEXT.message' | translate}}</span>
        </button>
        <!--   Follow     -->
        <button *ngIf="!isAuthUserProfile && !profileData?.am_i_following_this_user" (click)="followUnfollowUser()"
          class="custom-btn custom-btn--primary tl-justify-center">
          <span>{{'NEW_TEXT.follow' | translate}}</span>
        </button>
        <!--   Unfollow     -->
        <button *ngIf="!isAuthUserProfile && profileData?.am_i_following_this_user" (click)="followUnfollowUser()"
          class="custom-btn custom-btn--gray">
          <span>{{'NEW_TEXT.unfollow' | translate}}</span>
          <img src="../../../assets/icons/outline/icon-minus-cirlce.svg" alt="">
        </button>
        <button *ngIf="isAuthUserProfile && (profileData?.subscriptions | checkActiveRole) === UserRoles.expert"
          class="custom-btn custom-btn--gray" [routerLink]="[PAGES_AND_PATHS.settings.pagePath]">
          <span>{{'NEW_TEXT.view_insights' | translate}}</span>
          <img src="../../../assets/icons/outline/icon-statistics.svg" alt="">
        </button>
      </div>

      <div *ngIf="(profileData?.subscriptions | checkActiveRole) === UserRoles.company" class="wrapper-trending">
        <div class="header-trending">
          <span>{{'NEW_TEXT.trending_items' | translate}}</span>
          <img [routerLink]="[PAGES_AND_PATHS.trendingItems.pagePath, userId]"
            src="../../../assets/icons/icon-arrow-left.svg" alt="">
        </div>
        <swiper-container class="mySwiper wrapper-trending-cards" slides-per-view="2.1">
          <swiper-slide *ngFor="let item of profileData.trending_items"
            [routerLink]="[PAGES_AND_PATHS.singleItem.pagePath, item.id]">
            <div class="wrapper-trending-card">
              <div class="header-trending-card">
                <img class="wrapper-item-img"
                  [src]="item.lyst_item_image_url ? item.lyst_item_image_url : './assets/images/no-image.png'" alt="">
                <span>{{item.name}}</span>
              </div>
              <div class="content-trending-card">
                <div class="likes-trending-item" (click)="toggleTrendingItemLike(item)">
                  <div class="btn-trending-like" [ngClass]="{'liked': item.am_i_favorite_this_lyst_item}">
                    <img class="icon-outline" src="../../../assets/icons/outline/icon-heart.svg" alt="">
                    <img class="icon-fill" src="../../../assets/icons/fill/icon-heart.svg" alt="">
                  </div>
                  <span>{{item.favorite_users_count}} {{item.favorite_users_count === 1 ? 'like' : 'likes'}}</span>
                </div>
                <div class="wrapper-rating-trending-item">
                  <app-item-rating [averageRating]="item?.average_rating" [reviewsCount]="item?.reviews_count">
                  </app-item-rating>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
      <div class="wrapper-custom-tabs">
        <div class="custom-tab" [ngClass]="{'active': activeTab === ProfileTabsEnums.lysts}"
          (click)="activeTab = ProfileTabsEnums.lysts">
          <img src="../../../../../assets/icons/outline/icon-posts.svg" alt="">
          <span>{{ProfileTabsEnums.lysts}}</span>
        </div>
        <div class="custom-tab" [ngClass]="{'active': activeTab === ProfileTabsEnums.posts}"
          (click)="activeTab = ProfileTabsEnums.posts">
          <img src="../../../../../assets/icons/outline/icon-my-lists.svg" alt="">
          <span>{{ProfileTabsEnums.posts}}</span>
        </div>
      </div>
      <tl-lists-tab
        *ngIf="activeTab === ProfileTabsEnums.lysts && userId"
        [userId]="userId">
      </tl-lists-tab>
      <tl-posts-tab
        *ngIf="activeTab === ProfileTabsEnums.posts"
        [profileData]="profileData"
        [isAuthUser]="isAuthUserProfile"
        [baseUrl]="baseUrl"
        [userId]="userId">
      </tl-posts-tab>
    </div>
  </div>
</div>
<tl-sharing-options-modal *ngIf="isShareProfileModalOpen" [entityType]="ShareEntitiesEnums.profile" [entityId]="userId"
  [urlForShare]="profileUrl" (closeModal)="isShareProfileModalOpen = false">
</tl-sharing-options-modal>
